import { render, staticRenderFns } from "./TeacherSchoolForm.vue?vue&type=template&id=a46cae0c"
import script from "./TeacherSchoolForm.vue?vue&type=script&lang=js"
export * from "./TeacherSchoolForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports